
<script>
import DateRangePicker from "vue2-daterange-picker";
import OrderList from "./order_tabs/order-list";
import pagination from "laravel-vue-pagination";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { orderService } from "../../services";
import { date_ranges, debounce, order_statuses } from "../../Helper/helper";
export default {
  components: { DateRangePicker, OrderList, pagination },
  props: ["filterChange"],
  data() {
    let startDate =
      (this.$route.query.date &&
        this.moment(this.$route.query.date).startOf("day").toDate()) ||
      this.moment().startOf("day").toDate();
    let endDate =
      (this.$route.query.date &&
        this.moment(this.$route.query.date).startOf("day").toDate()) ||
      this.moment().endOf("day").toDate();
    return {
      dateRange: { startDate, endDate },
      statuses: order_statuses,
      orders: null,
      ordersCount: null,
      loading: false,
      limit: 1,
      orderStatus : order_statuses.placed,
      filters: {
        status: order_statuses.placed,
        search: "",
        start_date: this.moment().format("YYYY-MM-DD"),
        end_date: this.moment().format("YYYY-MM-DD"),
        abandonedstatus: "",
      },
      driverColumns: [
        {
          key: "driver",
          label: this.trans.get("__JSON__.Driver Name", {
            driver: this.$auth.getDriverName(),
          }),
          sortable: false,
          formatter: (value) =>
            value.length > 0
              ? `${value[0].firstname + " " + value[0].lastname}`
              : "-",
        },
      ],
      scheduleColumns: [
        {
          key: "future_delivery_date",
          label: this.trans.get("__JSON__.Schedule Time"),
          sortable: false,
        },
      ],
      cancelledColumns: [
        {
          key: "cancelled_date",
          label: this.trans.get("__JSON__.Cancel Time"),
          sortable: false,
        },
      ],
      confirmedColumns: [
        // {
        //   key: "assign",
        //   label: this.trans.get("__JSON__.Assign"),
        //   sortable: false,
        //   requiresAdmin: true,
        // },
        {
          key: "driver",
          label: this.trans.get("__JSON__.Driver Name", {
            driver: this.$auth.getDriverName(),
          }),
          
          sortable: false,
          formatter: (value) =>
            value && value.length > 0
              ? `${value[0].firstname + " " + value[0].lastname}`
              : "-",
        },
      ],
      readyToDeliveryColumns: [
        // {
        //   key: "assign",
        //   label: this.trans.get("__JSON__.Assign"),
        //   sortable: false,
        //   requiresAdmin: true,
        // },
        {
          key: "driver",
          label: this.trans.get("__JSON__.Driver Name", {
            driver: this.$auth.getDriverName(),
          }),
          sortable: false,
          formatter: (value) =>
            value.length > 0
              ? `${value[0].firstname + " " + value[0].lastname}`
              : "-",
        },
      ],
      debounce,
      searchChanged: debounce(() => {
        this.getOrders();
        this.getOrdersCount();
      }, 500),
      date_ranges: date_ranges,
      dateDots: {},
    };
  },
  watch: {
    "$auth.orders": function () {
      this.getData();
    },
    "$route.query": function () {
      this.dateRange = this.changeSettingRange();
      this.filters = {
        
        ...this.filters,
        status: this.$route.query.status
          ? this.$route.query.status
          : order_statuses.placed,
        start_date:
          this.$route.query.date ||
          this.moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date:
          this.$route.query.date ||
          this.moment(this.dateRange.endDate).format("YYYY-MM-DD"),
      };

      this.getOrders();
      this.getOrdersCount();
    },
  },
  mounted() {
   
    this.dateRange = this.changeSettingRange();
    this.filters = {
      ...this.filters,
      status: this.$route.query.status
        ? this.$route.query.status
        : order_statuses.placed,
      start_date:
        this.$route.query.date ||
        this.moment(this.dateRange.startDate).format("YYYY-MM-DD"),
      end_date:
        this.$route.query.date ||
        this.moment(this.dateRange.endDate).format("YYYY-MM-DD"),
    };
    this.getOrders();
    this.getOrdersCount();
    this.fetchDateDots(this.filters.start_date, this.filters.end_date);
  },
  computed: {
    getSelected: function () {
      const { start_date, end_date } = this.filters;
      const date_ranges = this.date_ranges();
      return Object.keys(date_ranges).reduce((accu, day) => {
        if (
          this.moment(date_ranges[day][0]).format("YYYY-MM-DD") == start_date &&
          this.moment(date_ranges[day][1]).format("YYYY-MM-DD") == end_date
        ) {
          return day;
        }
        return accu;
      }, "");
    },
  },
  methods: {
    updateValues(date) {
      this.filters = {
        ...this.filters,
        start_date: this.moment(date.startDate.toISOString()).format(
          "YYYY-MM-DD"
        ),
        end_date: this.moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
      this.getNewOrders();
      this.getData();
      this.fetchDateDots(this.filters.start_date, this.filters.end_date);
    },
    getData() {
      this.getOrders();
      this.getOrdersCount();
    },
    getNewOrders() {
      // 
        this.getData();
      //
      orderService
        .getNewOrders()
        .then((response) => {
          if (typeof response.data.result == "object") {
            if (response.data.result.length !== this.$auth.orders.length) {
              this.$auth.updateOrders(response.data.result);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    dateFormat(classes, date) {
      this.filters = {
        ...this.filters,
        start_date: this.moment(date.startDate.toISOString()).format(
          "YYYY-MM-DD"
        ),
        end_date: this.moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
    },
    getOrders(page = 1) {
      this.loading = true;
      orderService
        .getOrders({
          ...this.filters,
          page,
        })
        .then((response) => {
          this.orders = response.data.result;
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.$emit("filterChange", this.filters);
        })
        .catch(function (error) {
          this.loading = false;
          // console.log(error);
        });
    },
    onTabChanged(tabIndex) {
     
      const {
        placed,
        //confirmed,
        readytocollect,
        // collected,
        ontheway,
        delivered,
        cancelled,
        paymentfailure,
      } = order_statuses;
      var statuses = [
        placed,
        //confirmed,
        readytocollect,
        // collected,
        ontheway,
        delivered,
        cancelled,
        paymentfailure,
      ];
     
      this.filters.status = statuses[tabIndex];
      this.orderStatus = statuses[tabIndex];
      
      if (this.filters.status != "PaymentFailure") {
        this.filters.abandonedstatus = "";
      }
      
      this.getData();
      this.getNewOrders();
    },
    getOrdersCount() {
      this.loading = true;
      orderService
        .getOrdersCount({
          ...this.filters,
        })
        .then((response) => {
          this.loading = false;
          this.ordersCount = response.data.result;
        })
        .catch(function (error) {
          this.loading = false;
          // console.log(error);
        });
    },
    changeSettingRange() {
      var now = this.moment();
      var then = this.moment();
      if (this.$auth && this.$auth.setting) {
        var range = this.$auth.setting.order_dashboard_default_time;
        var date_ranges = this.date_ranges();
        var keys = Object.keys(date_ranges);
        switch (range) {
          case "0":
            return {
              startDate: date_ranges[keys[0]][0],
              endDate: date_ranges[keys[0]][1],
            };
          case "1":
            return {
              startDate: date_ranges[keys[1]][0],
              endDate: date_ranges[keys[1]][1],
            };
          case "6":
            return {
              startDate: date_ranges[keys[2]][0],
              endDate: date_ranges[keys[2]][1],
            };
          case "29":
            return {
              startDate: date_ranges[keys[3]][0],
              endDate: date_ranges[keys[3]][1],
            };
          case "365":
            return {
              startDate: date_ranges[keys[4]][0],
              endDate: date_ranges[keys[4]][1],
            };
          case "101":
            return {
              startDate: date_ranges[keys[5]][0],
              endDate: date_ranges[keys[5]][1],
            };
          default:
            return {
              startDate: now.startOf("day").toDate(),
              endDate: then.endOf("day").toDate(),
            };
        }
      }
      return {
        startDate: now.startOf("day").toDate(),
        endDate: then.endOf("day").toDate(),
      };
    },
    emitChange() {
      //console.log('in')
      this.getNewOrders();
      this.getData();
    },
    fetchDateDots(startDate, endDate) {
      orderService
        .getOrderDateDots({ start_date: startDate, end_date: endDate })
        .then((response) => {
          this.dateDots = response.data.result || {};
        })
        .catch(() => {});
    },
    getDateDotClass(date) {
      const key = this.moment(date).format("YYYY-MM-DD");
      const dots = this.dateDots[key];
      if (!dots) return {};
      return {
        "dot-new-request": dots[10] > 0,
        "dot-ready-collect": dots[22] > 0,
        "dot-on-the-way": dots[6] > 0,
      };
    },
    dateHasDots(date) {
      const key = this.moment(date).format("YYYY-MM-DD");
      const dots = this.dateDots[key];
      return dots && (dots[10] > 0 || dots[22] > 0 || dots[6] > 0);
    },
    abandonedstatusEmitchanged(val) {
      this.filters = {
        ...this.filters,
        abandonedstatus: val,
      };
      this.getNewOrders();
      this.getData();
    },
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="justify-content-end row m-order-list">
                <div class="" v-if="filters.status != 'Scheduled'">
                  <div class="form-group ml-2">
                    <!-- <b-form-group id="example-date-time" label-cols-sm="2" label-cols-lg="2" label="Date and time" label-for="date-time">
                                    <b-form-input id="date-time" value="2019-08-19T13:45:00" type="datetime-local"></b-form-input>
                                </b-form-group> -->
                    <div class="date-range-list">
                      <label
                        >{{ trans.get("__JSON__.Date") }}
                        {{
                          getSelected != "" ? "(" + getSelected + ")" : ""
                        }}
                        :</label
                      >
                      <date-range-picker
                        ref="picker"
                        :locale-data="{
                          firstDay: 1,
                          format: 'dd-mm-yyyy',
                        }"
                        :showDropdowns="true"
                        :showWeekNumbers="true"
                        opens="left"
                        v-model="dateRange"
                        class="w-100"
                        :ranges="date_ranges()"
                        @update="updateValues"
                      >
                        <template
                          v-slot:input="picker"
                          style="min-width: 350px"
                        >
                          {{
                            moment(picker.startDate.toISOString()).format(
                              "DD-MM-YYYY"
                            ) | date
                          }}
                          -
                          {{
                            moment(picker.endDate.toISOString()).format(
                              "DD-MM-YYYY"
                            ) | date
                          }}
                        </template>
                        <template v-slot:date="{ date }">
                          <span>{{ date.getDate() }}</span>
                          <div
                            v-if="dateHasDots(date)"
                            class="date-dots-container"
                          >
                            <span
                              v-if="dateDots[moment(date).format('YYYY-MM-DD')] && dateDots[moment(date).format('YYYY-MM-DD')][10] > 0"
                              class="date-dot dot-new-request"
                            ></span>
                            <span
                              v-if="dateDots[moment(date).format('YYYY-MM-DD')] && dateDots[moment(date).format('YYYY-MM-DD')][22] > 0"
                              class="date-dot dot-ready-collect"
                            ></span>
                            <span
                              v-if="dateDots[moment(date).format('YYYY-MM-DD')] && dateDots[moment(date).format('YYYY-MM-DD')][6] > 0"
                              class="date-dot dot-on-the-way"
                            ></span>
                          </div>
                        </template>
                      </date-range-picker>
                    </div>
                  </div>
                </div>
                <div class="ml-2">
                  <div class="search-box mr-2 mb-0 d-inline-block form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get("__JSON__.Search") }} :</label>
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          v-model="filters.search"
                          @keyup="searchChanged"
                          :placeholder="trans.get('__JSON__.Search...')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <b-tabs
                justified
                nav-class="nav-tabs-custom mt-0 order-tabs"
                content-class="p-3 text-muted"
                lazy
                @activate-tab="onTabChanged"
              >
                <b-tab :button-id="statuses.placed">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.New Requests")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.placed_orders &&
                        ordersCount.placed_orders !== '0'
                      "
                      class="badge badge-success font-size-12"
                    >
                      {{ (ordersCount && ordersCount.placed_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :orderStatus="orderStatus"
                    :loading="loading"
                    @refreshData="getNewOrders"
                    :extra-columns="confirmedColumns"
                  />
                </b-tab>
                <b-tab :button-id="statuses.readytocollect">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-check"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Ready To Collect")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.ready_orders &&
                        ordersCount.ready_orders !== '0'
                      "
                      class="badge badge-primary font-size-12"
                    >
                      {{ (ordersCount && ordersCount.ready_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :orderStatus="orderStatus"
                    :loading="loading"
                    @refreshData="emitChange"
                    :extra-columns="confirmedColumns"
                  />
                </b-tab>
                <!-- <b-tab :button-id="statuses.collected">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-bus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Collected")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.collect_orders &&
                        ordersCount.collect_orders !== '0'
                      "
                      class="badge badge-info font-size-12"
                    >
                      {{ (ordersCount && ordersCount.collect_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :loading="loading"
                    @refreshData="emitChange"
                    :extra-columns="readyToDeliveryColumns"
                  />
                </b-tab> -->
                <b-tab :button-id="statuses.ontheway">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-bus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.On The Way")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.ontheway_orders &&
                        ordersCount.ontheway_orders !== '0'
                      "
                      class="badge badge-warning font-size-12"
                    >
                      {{ (ordersCount && ordersCount.ontheway_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :orderStatus="orderStatus"
                    :loading="loading"
                    :extra-columns="driverColumns"
                    @refreshData="emitChange"
                  />
                </b-tab>
                <b-tab :button-id="statuses.delivered">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-bus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Delivered")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.delivered_orders &&
                        ordersCount.delivered_orders !== '0'
                      "
                      class="badge badge-info font-size-12"
                    >
                      {{ (ordersCount && ordersCount.delivered_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :orderStatus="orderStatus"
                    :loading="loading"
                    :extra-columns="driverColumns"
                    @refreshData="emitChange"
                  />
                </b-tab>
                <b-tab :button-id="statuses.cancelled">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-times"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Cancelled")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.cancelled_orders &&
                        ordersCount.cancelled_orders !== '0'
                      "
                      class="badge badge-danger font-size-12"
                    >
                      {{ (ordersCount && ordersCount.cancelled_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :orders="orders"
                    :orderStatus="orderStatus"
                    :loading="loading"
                    @refreshData="emitChange"
                  />
                </b-tab>
                <!-- <b-tab
                  :button-id="statuses.paymentfailure"
                  v-if="!$auth.partner_login"
                >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-credit-card"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Abandoned")
                    }}</span>
                    <span
                      v-if="
                        ordersCount &&
                        ordersCount.failed_orders &&
                        ordersCount.failed_orders !== '0'
                      "
                      class="badge badge-danger font-size-12"
                    >
                      {{ (ordersCount && ordersCount.failed_orders) || 0 }}
                    </span>
                  </template>
                  <OrderList
                    :status="filters.status"
                    :orders="orders"
                    :loading="loading"
                    @refreshData="emitChange"
                    @abandonedstatusEmitchanged="
                      abandonedstatusEmitchanged($event)
                    "
                  />
                </b-tab> -->
              </b-tabs>
            </div>
            <div class="col-12">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0" v-if="orders">
                  <pagination
                    :data="orders"
                    :limit="limit"
                    @pagination-change-page="getOrders"
                  ></pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.date-dots-container {
  display: flex;
  justify-content: center;
  gap: 3px;
  margin-top: -4px;
  margin-bottom: 2px;
}
.date-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.dot-new-request {
  background-color: #28a745;
}
.dot-ready-collect {
  background-color: #007bff;
}
.dot-on-the-way {
  background-color: #f1b44c;
}
</style>